import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import {
  coprehensiveCyberAssessments,
  cyberSecurityTrainings,
  heroSectionCyber,
  incidentResponsePlanDevelopment,
  simulatedAttacksAndPenetrationTesting,
} from 'images/expertise';
import DetailPage from 'containers/expertise/DetailPage';

const CyberSecurity: NextPage = () => {
  return (
    <>
      <Header
        title="Cyber Security"
        description="Strengthen Your Cyber Security with Advanced Training and Response Solutions to Protect Against Evolving Threats"
        image={heroSectionCyber}
      />
      <DetailPage
        listBlocks={[
          {
            bgImage: coprehensiveCyberAssessments,
            id: 'coprehensiveCyberAssessments',
            title: 'Comprehensive Cyber Assessments',
            description:
              'Thorough evaluations for both employees and organizations to identify vulnerabilities and enhance defenses against cyber threats.',
            hasListItems: true,
          },
          {
            bgImage: cyberSecurityTrainings,
            id: 'cyberSecurityTrainings',
            title: 'Cyber Security Trainings',
            description:
              'Customized programs to educate your team on recognizing and responding to phishing and social engineering attacks.',
            hasListItems: true,
          },
          {
            bgImage: incidentResponsePlanDevelopment,
            id: 'incidentResponsePlanDevelopment',
            title: 'Incident Response Plan Development',
            description:
              'Create robust plans to ensure swift and effective responses to cyber incidents, minimizing damage and ensuring business continuity.',
            hasListItems: true,
          },
          {
            bgImage: simulatedAttacksAndPenetrationTesting,
            id: 'simulatedAttacksAndPenetrationTesting',
            title: 'Simulated Attacks and Penetration Testing',
            description:
              'Conduct realistic cyber-attack simulations to test defenses and identify weaknesses, with strategic recommendations for improvement.',
            hasListItems: true,
          },
        ]}
        // text={
        //   'In collaboration with Xinom Technologies, an innovative provider of advanced cybersecurity solutions, Utilities One is strengthening its defense against cyber threats. Together, we are delivering state-of-the-art cybersecurity solutions, ensuring robust protection and enhanced security for all our clients.'
        // }
        // linkTitle={'Xinom Technologies'}
        // link={'https://xinom.ai/'}
      />
    </>
  );
};

export default CyberSecurity;
